import React from 'react'

import SelectField from '~/components/Fields/SelectField'

const options = [
  { value: null, name: 'All' },
  { value: 'active', name: 'Active' },
  { value: 'inactive', name: 'Inactive' },
]

function UserStatusField (props) {
  return (
    <SelectField
      name="status"
      label="Status"
      options={options}
      {...props}
    />
  )
}

export default UserStatusField
